document.addEventListener("DOMContentLoaded", function () {
  const contactToggle = document.querySelector(".contact-toggle");
  const contactItems = document.querySelector(".contact-items");

  if (contactToggle && contactItems) {
    // Function to toggle the contact panel
    const toggleContactPanel = () => {
      const isExpanded = contactToggle.getAttribute("aria-expanded") === "true";
      contactToggle.setAttribute("aria-expanded", !isExpanded);
      contactItems.classList.toggle("active");
      closeOtherDropdowns(contactItems);
    };

    // Function to close the contact panel
    const closeContactPanel = () => {
      contactItems.classList.remove("active");
      contactToggle.setAttribute("aria-expanded", "false");
    };

    // Function to close other dropdowns
    const closeOtherDropdowns = () => {
      const mobileToggle = document.querySelector(".mobile-toggle");
      const navMenu = document.querySelector(".nav-menu");

      if (contactItems.classList.contains("active")) {
        if (mobileToggle) {
          mobileToggle.setAttribute("aria-expanded", "false");
        }
        if (navMenu) {
          navMenu.classList.remove("active");
        }
      }
    };

    // Event listener for the contact toggle button
    contactToggle.addEventListener("click", toggleContactPanel);

    // Event listener to close the contact panel when clicking outside
    document.addEventListener("click", (event) => {
      if (
        !contactToggle.contains(event.target) &&
        !contactItems.contains(event.target) &&
        contactItems.classList.contains("active")
      ) {
        closeContactPanel();
      }
    });
  }
});

//update this

document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    const redirects = {
      227: "/thank-you-for-your-application",
      934: "/thank-you-for-your-registration/",
    };

    const formId = event.detail.contactFormId;

    if (redirects[formId]) {
      window.location.href = redirects[formId];
    }
  },
  false
);
